import { useSelector } from 'react-redux';
import React from 'react';
import styled from '@emotion/styled';
import Paper from '@base/Paper/Paper';
import BreadCrumbs from '@base/BreadCrumbs/BreadCrumbs';
import H2 from '@base/H2/H2';
import breadcrumbs from '@utils/breadcrumbs';
import { Spacings, mediaQuery, Fonts } from '@styles/index';
import { PlusTopologySource } from '@constants/index';
import pushRoute from '@utils/pushRoute';
import { useRouter } from 'next/router';
import { getIsSubscribedToOffline } from '@selectors/subscription';

interface IHeaderNavBar {
  gridColumn: string;
}

const HeaderNavBar = styled(Paper)<IHeaderNavBar>`
  width: 100% !important;
  margin-bottom: ${Spacings.SPACING_10B};
  border-radius: ${Spacings.SPACING_2B};
  padding: ${Spacings.SPACING_8B} ${Spacings.SPACING_12B};
  ${mediaQuery.uptoMobile} {
    background: var(--color-base-0);
    box-shadow: none;
    padding: ${Spacings.SPACING_6B} 0 0 0;
    margin-bottom: ${Spacings.SPACING_8B};
  }
`;

const Title = styled(H2)`
  margin-top: ${Spacings.SPACING_4B};
  font-weight: ${Fonts.HEAVY};
  height: ${Spacings.SPACING_12B};
  line-height: 150%;
`;

const sourcesType = Object.keys(PlusTopologySource).map(
  (key) => PlusTopologySource[key]
);

export interface ISyllabusHomePageProps {
  source: typeof sourcesType;
  goalUID: string;
  topicUID?: string;
}

const headerTags = (goalTopology, isOfflineSubscription) => {
  const tags = [];
  if (goalTopology) {
    tags.push(
      ...breadcrumbs.getPlusTopicsTags(goalTopology, isOfflineSubscription)
    );
  }
  return tags;
};

const Header = ({ goalTopology, fromStore }) => {
  const {
    query: { goalSlug, goalUID }
  } = useRouter();

  const goBack = () => {
    if (fromStore) window.history.back();
    pushRoute(
      '/goal/[goalSlug]/[goalUID]/planner',
      `/goal/${goalSlug}/${goalUID}/planner`
    );
  };

  const isOfflineSubscription = useSelector(getIsSubscribedToOffline(goalUID));
  return (
    <>
      <HeaderNavBar gridColumn="span 18">
        <BreadCrumbs
          tags={
            !fromStore ? headerTags(goalTopology, isOfflineSubscription) : null
          }
          onBackClick={goBack}
          useBackClick
        />
        <Title>Notes</Title>
      </HeaderNavBar>
    </>
  );
};

const sources = Object.keys(PlusTopologySource).map(
  (key) => PlusTopologySource[key]
);

export default Header;
